import { ComponentFactoryResolver, ComponentRef, Type, ViewContainerRef } from '@angular/core';
import { loadProposalHistoryGridComponent } from './lazy-load-proposal-history-grid';

let cachedGridComponent: Type<any> | null = null;

export async function mountProposalHistoryGrid(params: {
  host: ViewContainerRef;
  componentFactoryResolver: ComponentFactoryResolver;
  accountId?: string;
  maxHeight?: string;
  loadAll?: boolean;
  onMountStart?: () => void;
  onMountSuccess?: (ref: ComponentRef<any>) => void;
  onMountError?: (error: unknown) => void;
}): Promise<ComponentRef<any>> {
  params.onMountStart?.();
  if (!cachedGridComponent) {
    try {
      cachedGridComponent = await loadProposalHistoryGridComponent();
    } catch (error) {
      params.onMountError?.(error);
      throw error;
    }
  }

  try {
    const componentFactory = params.componentFactoryResolver.resolveComponentFactory(cachedGridComponent);
    params.host.clear();
    const ref = params.host.createComponent(componentFactory);
    ref.instance.accountId = params.accountId;
    ref.instance.maxHeight = params.maxHeight;
    ref.instance.setLoadAllMode?.(!!params.loadAll);
    params.onMountSuccess?.(ref);
    return ref;
  } catch (error) {
    params.onMountError?.(error);
    throw error;
  }
}
